<template>
  <span class="help-avatar" :style="avatarStyle" role="img" :aria-label="`${name} avatar`">
    <img
      :src="shownUrl"
      alt=""
      class="help-avatar-image"
      draggable="false"
      @error="useDefault"
    >
  </span>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import defaultAvatar from '../../../assets/helpchatdefault.png';

const props = defineProps({
  url: { type: String, default: null },
  name: { type: String, default: 'Ray' },
  size: { type: Number, default: 32 },
});

const failed = ref(false);
watch(() => props.url, () => {
  failed.value = false;
});

const shownUrl = computed(() => (!props.url || failed.value ? defaultAvatar : props.url));

function useDefault() {
  failed.value = true;
}

const avatarStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<style scoped>
.help-avatar {
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0 0 0 2px white, 0 1px 3px rgb(0 0 0 / 20%);
}

.help-avatar-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
</style>
